__turbopack_context__.v({
  "collapsed": "curriculum-section-module-scss-module__9JCrHq__collapsed",
  "course-lecture-title": "curriculum-section-module-scss-module__9JCrHq__course-lecture-title",
  "hidden-on-mobile": "curriculum-section-module-scss-module__9JCrHq__hidden-on-mobile",
  "item-content-summary": "curriculum-section-module-scss-module__9JCrHq__item-content-summary",
  "item-description": "curriculum-section-module-scss-module__9JCrHq__item-description",
  "item-title": "curriculum-section-module-scss-module__9JCrHq__item-title",
  "panel": "curriculum-section-module-scss-module__9JCrHq__panel",
  "practice-test-questions-count": "curriculum-section-module-scss-module__9JCrHq__practice-test-questions-count",
  "preview-text": "curriculum-section-module-scss-module__9JCrHq__preview-text",
  "previewable-item": "curriculum-section-module-scss-module__9JCrHq__previewable-item",
  "row": "curriculum-section-module-scss-module__9JCrHq__row",
  "section-content-stats": "curriculum-section-module-scss-module__9JCrHq__section-content-stats",
  "section-title": "curriculum-section-module-scss-module__9JCrHq__section-title",
  "section-title-container": "curriculum-section-module-scss-module__9JCrHq__section-title-container",
  "toggle-item-description-button": "curriculum-section-module-scss-module__9JCrHq__toggle-item-description-button",
});
